"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSignupAppEvent = exports.sendSignupLandingEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a user signup
 * Event name: "web:landing:::signup"
 */
var sendSignupLandingEvent = function (platform) {
    (0, _1.sendEvent)("landing", null, null, "signup", { platform: platform });
};
exports.sendSignupLandingEvent = sendSignupLandingEvent;
/**
 * Sends an event that a user signup
 * Event name: "web:app:::signup"
 */
var sendSignupAppEvent = function (platform) {
    (0, _1.sendEvent)("app", null, null, "signup", { platform: platform });
};
exports.sendSignupAppEvent = sendSignupAppEvent;
